<ng-container [ngSwitch]="version">
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_1">
		<div [ngClass]="[wrapperClass]"
			 [style.padding-top.px]="isWebAppUser ? mobileAppHeader : mobileHeader" class="px-[20px] pb-[24px]">
			<div [ngClass]="[headerClass]" class="flex items-center justify-between">
				<div [ngClass]="{'gray-out':disable, 'no-back-button-wrapper':!showBackButton}">
					<app-back-navigation-button
						(goBack)="showBackButton && previousRoute()"
						[showDefaultIcon]="showBackButton"
						[buttonName]="previous">
					</app-back-navigation-button>
				</div>
				<div>
					<div *ngIf="currentStep">
						<app-time-line-progress
							[currentStep]="currentStep"
							[totalStep]="total"
							[useLargeFont]="true">
						</app-time-line-progress>
					</div>
				</div>
			</div>
			<div class="custom-header-title mt-[8px]">
				<ng-container *ngTemplateOutlet="note"></ng-container>
			</div>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_2">
		<div class="flex items-center justify-between">
			<div>
				<ng-container *ngTemplateOutlet="note"></ng-container>
			</div>
			<div>
				<div *ngIf="currentStep">
					<app-time-line-progress
						[currentStep]="currentStep"
						[totalStep]="total"
						[useLargeFont]="true">
					</app-time-line-progress>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_3">
		<div [ngClass]="[wrapperClass]" [style.padding-top.px]="isWebAppUser ? mobileAppHeader : mobileHeader" class="px-[20px] pb-[24px]">
			<div class="flex items-center justify-between">
				<div [ngClass]="{'gray-out':disable}">
					<app-back-navigation-button (goBack)="previousRoute()">
					</app-back-navigation-button>
				</div>
				<div>
					<ng-container *ngTemplateOutlet="note"></ng-container>
				</div>
				<div>
					<div *ngIf="currentStep">
						<app-time-line-progress [currentStep]="currentStep" [totalStep]="total" [useLargeFont]="true">
						</app-time-line-progress>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_4">
		<div [ngClass]="[wrapperClass]"
			 [style.padding-top.px]="isWebAppUser ? mobileAppHeader : mobileHeader" class="px-[20px] pb-[24px]">
			<div [ngClass]="[headerClass]" class="flex items-center">
				<div [ngClass]="{'gray-out':disable}">
					<app-back-navigation-button
						(goBack)="previousRoute()">
					</app-back-navigation-button>
				</div>
				<div class="grow text-center">
					<div class="text-[14px] text-black font-semibold leading-[19.6px]">
						{{previous}}
					</div>
				</div>
			</div>
			<div class="custom-header-title mt-[22px]">
				<ng-container *ngTemplateOutlet="note"></ng-container>
			</div>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_5">
		<div [ngClass]="[wrapperClass]"
			 [style.padding-top.px]="isWebAppUser ? mobileAppHeader : mobileHeader" class="px-[20px] pb-[24px]">
			<div [ngClass]="[headerClass]" class="flex items-center">
				<div [ngClass]="{'gray-out':disable}">
					<app-back-navigation-button
						(goBack)="previousRoute()">
					</app-back-navigation-button>
				</div>
				<div class="grow text-center">
					<div class="text-[20px] text-[#000E27] font-bold leading-[24.8px]">
						{{previous}}
					</div>
				</div>
			</div>
			<div class="text-center mt-[4px]">
				<div class="text-[12px] text-[#4D4D4D] leading-[17.76px] font-normal">
					{{description}}
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_6">
		<div [ngClass]="[wrapperClass]"
			 [style.padding-top.px]="isWebAppUser ? mobileAppHeader : mobileHeader" class="px-[20px] pb-[24px]">
			<div [ngClass]="[headerClass]" class="flex items-center">
				<div [ngClass]="{'gray-out':disable}">
					<app-back-navigation-button
						(goBack)="previousRoute()">
					</app-back-navigation-button>
				</div>
				<div class="grow text-center">
					<div class="text-[14px] text-black font-semibold leading-[19.6px]">
						{{previous}}
					</div>
				</div>
				<div *ngIf="currentStep">
						<app-time-line-progress [currentStep]="currentStep" [totalStep]="total" [useLargeFont]="true">
						</app-time-line-progress>
				</div>
			</div>
			<div class="custom-header-title mt-[22px]">
				<ng-container *ngTemplateOutlet="note"></ng-container>
			</div>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_7">
		<div [ngClass]="[wrapperClass]"
			 [style.padding-top.px]="isWebAppUser ? mobileAppHeader : mobileHeader" class="px-[20px] pb-[24px]">
			<div [ngClass]="[headerClass]" class="flex items-center">
				<div class="cursor-pointer" (click)="previousRoute()" [ngClass]="{'gray-out':disable}">
					<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M16.1705 19.8658C15.7312 20.3051 15.0188 20.3051 14.5795 19.8658L7.8295 13.1158C7.39017 12.6765 7.39017 11.9642 7.8295 11.5248L14.5795 4.77482C15.0188 4.33548 15.7312 4.33548 16.1705 4.77482C16.6098 5.21416 16.6098 5.92647 16.1705 6.36581L10.216 12.3203L16.1705 18.2748C16.6098 18.7142 16.6098 19.4265 16.1705 19.8658Z" fill="#0361F0"/>
					</svg>
				</div>
			</div>
			<div class="flex flex-col gap-[8px] text-black text-center mt-[40px]">
				<div class="text-[20px] leading-[24.8px] font-semibold">
					{{title}}
				</div>
				<div class="text-[12px] max-w-[286px] mx-auto leading-[17.76px] font-normal">
					{{description}}
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngSwitchCase="CustomTimelineVersion.version_8">
		<div [ngClass]="[wrapperClass]"
			 [style.padding-top.px]="isWebAppUser ? mobileAppHeader : mobileHeader" class="px-[20px] pb-[24px]">
			<div [ngClass]="[headerClass]" class="flex items-center">
				<div class="cursor-pointer" (click)="previousRoute()" [ngClass]="{'gray-out':disable}">
					<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M16.1705 19.8658C15.7312 20.3051 15.0188 20.3051 14.5795 19.8658L7.8295 13.1158C7.39017 12.6765 7.39017 11.9642 7.8295 11.5248L14.5795 4.77482C15.0188 4.33548 15.7312 4.33548 16.1705 4.77482C16.6098 5.21416 16.6098 5.92647 16.1705 6.36581L10.216 12.3203L16.1705 18.2748C16.6098 18.7142 16.6098 19.4265 16.1705 19.8658Z" fill="#0361F0"/>
					</svg>
				</div>
				<div class="grow text-center">
					<div class="text-[14px] text-black font-semibold leading-[19.6px]">
						{{previous}}
					</div>
				</div>
				<div *ngIf="currentStep">
					<app-time-line-progress [currentStep]="currentStep" [totalStep]="total" [useLargeFont]="true">
					</app-time-line-progress>
				</div>
			</div>
			<div class="custom-header-title mt-[22px]">
				<ng-container *ngTemplateOutlet="note"></ng-container>
			</div>
		</div>
	</ng-container>
</ng-container>
<ng-template #note>
	<div class="text-[24px] text-black/90 leading-[30px] font-bold">
		{{title}}
	</div>
	<div class="text-[14px] mt-[8px] font-normal leading-[20px] text-[#1A1A1A]">
		{{description}}
	</div>
</ng-template>
